import { css } from '@emotion/css'

export const recoverMyPasswordFormContainer = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 280px;
  justify-content: center;
`

export const titleSuccess = css`
  color: #545453;
`
